import React, { useEffect, useRef } from 'react';
import { TweenMax, Power2 } from 'gsap';

const CursorZoom = ({ onClick, isZoomedIn, isVisible }) => {

	const cursorEl = useRef(null);

	useEffect(() => {
		if (localStorage.getItem('is-touch') === 'true') return;

		window.addEventListener('mousemove', handleMouseMove)
		return function clean() {
			window.removeEventListener('mousemove', handleMouseMove);
		}
	});

	const handleMouseMove = e => {
		let isHiding = false
		if (e.target.closest('[data-cursor-hide]') !== null) {
			isHiding = true
		}
		if (isVisible === false) {
			isHiding = true
		}
		TweenMax.to(cursorEl.current, 0.6, {
			x: e.clientX,
			y: e.clientY,
			opacity: isHiding ? 0 : 1,
			ease: Power2.easeOut
		});
	}

	return (
		<>
			<div
				className={`CursorZoom ${isZoomedIn ? 'isZoomedIn' : ''}`}
				ref={cursorEl}
			>
				<div className="CursorZoom__Bg"></div>
				<div className="CursorZoom__Cross">
					<div className="CursorZoom__CrossLine CursorZoom__CrossLine--Left"></div>
					<div className="CursorZoom__CrossLine CursorZoom__CrossLine--Right"></div>
				</div>
			</div>
		</>
	)

}

export default CursorZoom;